import PropTypes from 'prop-types';
import H3 from '@base/H3/H3';
import P1 from '@base/P1/P1';
import { Spacings } from '@styles/index';
import styled from '@emotion/styled';
import Image from '@base/Image';
import Button from '@base/Button/Button';
import { useRouter } from 'next/router';
import useGroupsInvitationStore from '@stores/groups/groupsInvitationStore';

const InfoWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;

const StyH3 = styled(H3)`
  margin-bottom: ${Spacings.SPACING_4B};
`;

const ConfirmButton = styled(Button)`
  margin-bottom: ${Spacings.SPACING_4B};
`;

const ButtonWrapper = styled.div`
  margin-top: ${Spacings.SPACING_9B};
  color: var(--color-i-white);
`;

const HeadingWrapper = styled.div`
  max-width: 320px;
`;

const GroupChangeCard = ({ onCancel, onConfirm }) => {
  const router = useRouter();
  const { toggleGroupInvitationReceived } = useGroupsInvitationStore();

  const onClickCancel = () => {
    onCancel();
    toggleGroupInvitationReceived(false);
    const { goalSlug, goalUID } = router.query;
    router.replace(
      '/goal/[goalSlug]/[goalUID]',
      `/goal/${goalSlug}/${goalUID}`,
      { shallow: true }
    );
  };

  return (
    <div>
      <InfoWrapper>
        <HeadingWrapper>
          <StyH3>Change group</StyH3>
          <P1 color="var(--color-text-secondary)">
            You will lose current weeks points and all your recognitions that
            you have received from other group members.
          </P1>
        </HeadingWrapper>
        <Image
          src="groups/confirm-change.png"
          alt="confirm"
          height={80}
          width={80}
        />
      </InfoWrapper>
      <ButtonWrapper>
        <ConfirmButton color="red" label="I understand" onClick={onConfirm} />
        <Button
          color="black"
          label="Cancel"
          variant="hollow"
          onClick={onClickCancel}
        />
      </ButtonWrapper>
    </div>
  );
};

export default GroupChangeCard;

GroupChangeCard.prototypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};
